import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import constants from "@toolkit/Framework/Common/GoogleAnalytics/constants";

interface PushFunction extends Toolkit.GoogleAnalytics.Gtag {
    (command: object): void;
}

const push: PushFunction = (command: Toolkit.GoogleAnalytics.AnyCommandName | object, ...args: any[]) => {
    if (ga.enabled && typeof window !== "undefined" && window.dataLayer) {
        let result: any = command;

        if (typeof command === "string") {
            if (window.gtag && ga.trackingType === constants.trackingType.ga4) {
                window.gtag(command, ...args);
                return;
            }

            result = [command, ...args];

            if (command === "event") {
                result = { event: args[0] };
                result[ga.util.getEventPropertyName(result.event)] = args[1];
            } else if (command === "set") {
                result = args[0];
            }
        }

        ga.util.clearEventData(result);
        window.dataLayer.push(result);
    }
};

export default push;
